import type { AppProblemModel } from '@/services/api/AppProblemModel'
import { presentationFor } from './presentationFor'

/** The localized trailing " Try again in N seconds." suffix for a retryable problem. */
export const retrySuffix = (
  problem: AppProblemModel,
  t: (key: string, params: { seconds: number }) => string
): string => {
  const presentation = presentationFor(problem.code)
  if (!presentation.showRetryDelay || problem.retryDelaySeconds === null) return ''

  return ` ${t('presentation.errors.retryAfter', { seconds: problem.retryDelaySeconds })}`
}
